import axios from '@/axios';
import kitchensUrl from '@/apis/kitchens'

export default {
    fetchAll() {
        return axios.get(`${kitchensUrl}/concepts`);
    },
}